import { Component, OnInit, ViewChild, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl } from '@angular/forms';
import { ICountry, IState, IGetPermissionMandatoryField } from '../interface';
import { GeneralService } from 'src/app/services/general.service';
import { FacOpsDataService } from 'src/app/services/operations/facOpsDataService.service';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { UserSessionService } from 'src/app/services/usersession.service';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import { forkJoin } from 'rxjs';
import { CommonMethodService } from '../common-method.service';
import { ModalWrapperService } from 'src/app/services/modal-wrapper.service';

@Component({
    selector: 'app-military-form',
    templateUrl: './military-form.component.html',
    styleUrls: ['./military-form.component.scss'],
    standalone: false
})

export class MilitaryFormComponent implements OnInit {
    @Input() militaryInfoCallScriptFields = [];
    @Input() section;
    @Input() isCustomerInfo;
    @Input() isMilitaryChecked;
    @Output() militaryFilled: EventEmitter<any> = new EventEmitter<any>();
    @Output() militaryInfo: EventEmitter<any> = new EventEmitter<any>();
    @Output() militaryFormDirty: EventEmitter<any> = new EventEmitter<any>();
    militaryForm: FormGroup;
    private defaultCountryId = environment.defaultCountryId;
    countryList: ICountry[];
    countrySelectedMilitary: number;
    stateListMilitary: IState[];
    militaryFormDetails;
    militaryInfoSaved = false;
    modalRef: BsModalRef;
    countryId = 1;
    public PhoneNumberMask: String = '(000)000-0000';
    emailIdsPattern = '^([\\wÀ-ŸØ-öø-ÿ]+[\\wÀ-ŸØ-öø-ÿ!#$%?^&*+-=]*\\@[\\wÀ-ŸØ-öø-ÿ\-]+(?:\\.[\\wÀ-ŸØ-öø-ÿ]{2,}[\\wÀ-ŸØ-öø-ÿ]*)+)([\,\;]{1}[\\wÀ-ŸØ-öø-ÿ]+[\\wÀ-ŸØ-öø-ÿ!#$%?^&*+-=]*\\@[\\wÀ-ŸØ-öø-ÿ\-]+(?:\\.[\\wÀ-ŸØ-öø-ÿ]{2,}[\\wÀ-ŸØ-öø-ÿ]*)+)*$';
    militaryInfoReqList = [];
    tempisMilitaryChecked = false;
    emptyStateList = false;
    @ViewChild('MilitaryModal', { static: true }) militaryModal: ModalDirective;
    componentname;
    formName;
modalConfig = {
  backdrop: 'static'
};
    public onStartfocus(args): void {
        args.selectionStart = 1;
        args.selectionEnd = 1;
    }
    constructor(private formBuilder: FormBuilder,
        private generalService: GeneralService,
        private modalWrapper: ModalWrapperService,
        private facOpsDataService: FacOpsDataService,
        private userSessionService: UserSessionService,
        private commonMethodService: CommonMethodService) { }

    ngOnInit() {
        this.getCountries();
        this.militaryForm = this.formBuilder.group({
            ServiceMemberName: ['', [Validators.required, this.generalService.noWhitespaceValidator]],
            DOD: ['', [Validators.required]],
            MilitaryDeploymentDate: ['', [Validators.required, this.generalService.noWhitespaceValidator]],
            MilitaryIdExpDate: ['',[Validators.required, this.generalService.noWhitespaceValidator]],
            MilitaryRank: ['', [Validators.required, this.generalService.noWhitespaceValidator]],
            MilitaryUnitName: ['', [Validators.required, this.generalService.noWhitespaceValidator]],
            COFirstName: ['', [Validators.required, this.generalService.noWhitespaceValidator]],
            COLastName: ['', [Validators.required, this.generalService.noWhitespaceValidator]],
            CORank: ['', [Validators.required, this.generalService.noWhitespaceValidator]],
            COAddress: ['', [Validators.required, this.generalService.noWhitespaceValidator]],
            COCity: ['', [Validators.required, this.generalService.noWhitespaceValidator]],
            COState: ['', [Validators.required]],
            COZipCode: ['', [Validators.required, this.generalService.noWhitespaceValidator]],
            COCountry: ['', [Validators.required]],
            COCellPhone: [''],
            COCellPhoneDialInCode: [''],
            COFax: [''],
            COFaxDialInCode: [''],
            COEmail: ['', Validators.pattern(this.emailIdsPattern)],
            MilitaryBranch: ['', [Validators.required, this.generalService.noWhitespaceValidator]],
            MilitaryBase: ['', [Validators.required, this.generalService.noWhitespaceValidator]]
        });
        this.patchMilitaryForm();
        if (this.isCustomerInfo) {
          this.componentname = "faceops-customer-customerInfo.component.html";
          this.formName = "MilitaryInfoForm";
        } else {
          this.componentname = "military-form.component.html";
          this.formName = "militaryForm";
        }
        this.setMandatoryField();
        this.tempisMilitaryChecked = this.isMilitaryChecked;
        this.militaryForm.valueChanges.subscribe((value: any) => {
            if (this.militaryForm.dirty) {
                this.tempisMilitaryChecked = true;
                console.log('template form dirty - yes: ', value);
            } else {
            }
        });
    }

    patchMilitaryForm() {
        if ((this.getMilitaryService !== null) && (this.getMilitaryService !== undefined)) {
            this.militaryForm.patchValue({
                ServiceMemberName: this.getMilitaryService.ServiceMemberName,
                DOD: this.getMilitaryService.DOD,
                MilitaryDeploymentDate: this.getMilitaryService.MilitaryDeploymentDate,
                MilitaryIdExpDate: this.getMilitaryService.MilitaryIdExpDate,
                MilitaryRank: this.getMilitaryService.MilitaryRank,
                MilitaryUnitName: this.getMilitaryService.MilitaryUnitName,
                COFirstName: this.getMilitaryService.COFirstName,
                COLastName: this.getMilitaryService.COLastName,
                CORank: this.getMilitaryService.CORank,
                COAddress: this.getMilitaryService.COAddress,
                COCity: this.getMilitaryService.COCity,
                COState: this.getMilitaryService.COState,
                COZipCode: this.getMilitaryService.COZipCode,
                COCountry: this.getMilitaryService.COCountry,
                COCellPhone: this.getMilitaryService.COCellPhone,
                COCellPhoneDialInCode: this.getMilitaryService.COCellPhoneDialInCode,
                COFax: this.getMilitaryService.COFax,
                COFaxDialInCode: this.getMilitaryService.COFaxDialInCode,
                COEmail: this.getMilitaryService.COEmail,
                MilitaryBase: this.getMilitaryService.MilitaryBase,
                MilitaryBranch: this.getMilitaryService.MilitaryBranch
            });
            this.onMilitaryCountryChange(this.getMilitaryService.COCountry, false)
        }
    }

    getCountries() {
        this.generalService.getCountries().subscribe((response: ICountry[]) => {
            this.countryList = response;
            this.getStatesForMilitary(this.defaultCountryId);
            this.militaryForm.patchValue({
                COCountry: this.defaultCountryId,
                COState: ''
            });
            this.onMilitaryCountryChange(this.defaultCountryId, false);
            if (!this.militaryForm.get('COCellPhoneDialInCode').dirty) {
                this.militaryForm.patchValue({ COCellPhoneDialInCode: this.defaultCountryId });
            } else { }
            if (!this.militaryForm.get('COFaxDialInCode').dirty) {
                this.militaryForm.patchValue({ COFaxDialInCode: this.defaultCountryId });
            }
            this.militaryForm.markAsUntouched();
            this.militaryForm.markAsPristine();
        });
    }

    onMilitaryCountryChange(obj, onCountryChange) {
        if (obj == 1 || obj == 2) {
            this.emptyStateList = false;
            this.militaryForm.controls['COState'].patchValue('');
            this.militaryForm.get('COState').enable();
            this.getCountryAndStated(obj, onCountryChange);
        } else {
            this.emptyStateList = true;
            this.stateListMilitary = [];
            this.militaryForm.patchValue({ COState: '0' });
            this.militaryForm.get('COState').disable();
        }
        if (!this.militaryForm.get('COCellPhoneDialInCode').dirty) {
            this.militaryForm.patchValue({ COCellPhoneDialInCode: obj });
        }
        if (!this.militaryForm.get('COFaxDialInCode').dirty) {
            this.militaryForm.patchValue({ COFaxDialInCode: obj });
        }
    }

    getCountryAndStated(countryId, onCountryChange) {
        const res1 = this.generalService.getCountry(countryId);
        const res2 = this.generalService.getStates(countryId);

        forkJoin([res1, res2]).subscribe(results => {
            let response1 = results[0];
            let response2 = results[1];

            this.countrySelectedMilitary = response1.Id;
            this.stateListMilitary = response2;
            if (!onCountryChange) {
                this.setMilitaryStateList = this.stateListMilitary;
            }
            if (this.countrySelectedMilitary !== this.getMilitaryService?.COCountry) {
                if (this.countrySelectedMilitary == 1 || this.countrySelectedMilitary == 2) {
                    this.militaryForm.patchValue({
                        COCountry: this.countrySelectedMilitary,
                        COState: ''
                    });
                } else {
                    this.militaryForm.patchValue({
                        COCountry: this.countrySelectedMilitary,
                        COState: '0'
                    });
                }
            } else {
                this.militaryForm.patchValue({
                    COCountry: this.countrySelectedMilitary,
                    COState: this.getMilitaryService.COState
                });
            }
            if (!this.militaryForm.get('COCellPhoneDialInCode').dirty) {
                this.militaryForm.patchValue({ COCellPhoneDialInCode: response1.Id });
            }
            if (!this.militaryForm.get('COFaxDialInCode').dirty) {
                this.militaryForm.patchValue({ COFaxDialInCode: response1.Id });
            }
        });
    }

    getStatesForMilitary(id) {
        this.generalService.getStates(id).subscribe((response: IState[]) => {
            this.stateListMilitary = response;
        });
    }

    getCOCountry(id) {
        this.generalService.getCountry(id).subscribe((response: ICountry) => {
            this.countrySelectedMilitary = response.Id;
            this.militaryForm.patchValue({
                COCountry: this.countrySelectedMilitary
            });
            if (!this.militaryForm.get('COCellPhoneDialInCode').dirty) {
                this.militaryForm.patchValue({ COCellPhoneDialInCode: response.Id });
            } else { }
            if (!this.militaryForm.get('COFaxDialInCode').dirty) {
                this.militaryForm.patchValue({ COFaxDialInCode: response.Id });
            } else { }
        });
    }

    clickOnMilitary() {
        this.modalWrapper.openDirective(this.militaryModal);
        if (this.getMilitaryService !== null && this.getMilitaryService !== undefined) {
            if (this.getMilitaryService.COCountry != undefined && (this.getMilitaryService.COCountry == 1 || this.getMilitaryService.COCountry == 2)) {
                this.militaryForm.get('COState').enable();
                this.militaryForm.patchValue({ MilitaryInfoForm: { COIState: '' } });
                this.emptyStateList = false;
                this.stateListMilitary = this.getMilitaryStateList;
            } else {
                this.emptyStateList = true;
                this.militaryForm.patchValue({ COState: '0' });
                this.militaryForm.get('COState').disable();
            }
            this.militaryForm.patchValue({
                ServiceMemberName: this.getMilitaryService.ServiceMemberName,
                DOD: this.getMilitaryService.DOD,
                MilitaryDeploymentDate: this.commonMethodService.getTimeZoneOffSetDate(this.getMilitaryService.MilitaryDeploymentDate),
                MilitaryIdExpDate: this.commonMethodService.getTimeZoneOffSetDate(this.getMilitaryService.MilitaryIdExpDate),
                MilitaryUnitName: this.getMilitaryService.MilitaryUnitName,
                MilitaryRank: this.getMilitaryService.MilitaryRank,
                COFirstName: this.getMilitaryService.COFirstName,
                COLastName: this.getMilitaryService.COLastName,
                CORank: this.getMilitaryService.CORank,
                COAddress: this.getMilitaryService.COAddress,
                COCity: this.getMilitaryService.COCity,
                COState: this.getMilitaryService.COState,
                COZipCode: this.getMilitaryService.COZipCode,
                COCountry: this.getMilitaryService.COCountry == undefined ? this.defaultCountryId : this.getMilitaryService.COCountry,
                COCellPhone: this.getMilitaryService.COCellPhone,
                COCellPhoneDialInCode: this.getMilitaryService.COCellPhoneDialInCode == undefined ? this.defaultCountryId : this.getMilitaryService.COCellPhoneDialInCode,
                COFax: this.getMilitaryService.COFax,
                COFaxDialInCode: this.getMilitaryService.COFaxDialInCode == undefined ? this.defaultCountryId : this.getMilitaryService.COFaxDialInCode,
                COEmail: this.getMilitaryService.COEmail,
                MilitaryBase: this.getMilitaryService.MilitaryBase,
                MilitaryBranch: this.getMilitaryService.MilitaryBranch
            });
        } else {
            this.onMilitaryCountryChange(this.militaryForm.value.COCountry, false);
        }
        this.militaryForm.markAsUntouched();
        this.militaryForm.markAsPristine();
        this.tempisMilitaryChecked = this.isMilitaryChecked;
    }

    onPipeDate(formDate) {
        if (formDate !== null && formDate !== '') {
            const tempDate = new Date(formDate);
            const datepipe: DatePipe = new DatePipe('en-US');
            const date = new Date(tempDate);
            return datepipe.transform(date, 'MM/dd/yyyy');
        }
    }

    onMilitarySave() {
        this.militaryFormDetails = {
            ServiceMemberName: this.militaryForm.value.ServiceMemberName === null ? '' : this.militaryForm.value.ServiceMemberName,
            DOD: this.militaryForm.value.DOD === null ? '' : this.militaryForm.value.DOD,
            MilitaryDeploymentDate: this.militaryForm.value.MilitaryDeploymentDate? this.onPipeDate(this.militaryForm.value.MilitaryDeploymentDate) : '',
            MilitaryIdExpDate: this.militaryForm.value.MilitaryIdExpDate ? this.onPipeDate(this.militaryForm.value.MilitaryIdExpDate) : '',
            MilitaryRank: this.militaryForm.value.MilitaryRank === null ? '' : this.militaryForm.value.MilitaryRank,
            MilitaryUnitName: this.militaryForm.value.MilitaryUnitName === null ? '' : this.militaryForm.value.MilitaryUnitName,
            COFirstName: this.militaryForm.value.COFirstName === null ? '' : this.militaryForm.value.COFirstName,
            COLastName: this.militaryForm.value.COLastName === null ? '' : this.militaryForm.value.COLastName,
            CORank: this.militaryForm.value.CORank === null ? '' : this.militaryForm.value.CORank,
            COAddress: this.militaryForm.value.COAddress === null ? '' : this.militaryForm.value.COAddress,
            COCity: this.militaryForm.value.COCity === null ? '' : this.militaryForm.value.COCity,
            COState: this.militaryForm.value.COState,
            COZipCode: this.militaryForm.value.COZipCode === null ? '' : this.militaryForm.value.COZipCode,
            COCountry: this.militaryForm.value.COCountry == '' || this.militaryForm.value.COCountry == null ? this.countryId : this.militaryForm.value.COCountry,
            COCellPhone: this.militaryForm.value.COCellPhone === null ? '' : this.militaryForm.value.COCellPhone,
            COCellPhoneDialInCode: this.militaryForm.value.COCellPhoneDialInCode,
            COFax: this.militaryForm.value.COFax === null ? '' : this.militaryForm.value.COFax,
            COFaxDialInCode: this.militaryForm.value.COFaxDialInCode,
            COEmail: this.militaryForm.value.COEmail === null ? '' : this.militaryForm.value.COEmail,
            MilitaryBase: this.militaryForm.value.MilitaryBase === null ? '' : this.militaryForm.value.MilitaryBase,
            MilitaryBranch: this.militaryForm.value.MilitaryBranch === null ? '' : this.militaryForm.value.MilitaryBranch
        };
        this.militaryInfoSaved = true;
        this.militaryForm.markAsUntouched();
        this.militaryModal.hide();
        setTimeout(() => {
            this.militaryFilled.emit(this.militaryInfoSaved);
        }, 200);
        this.militaryFormDirty.emit(this.militaryInfoSaved);
        this.militaryInfo.emit(this.militaryFormDetails);
        this.setMilitaryService = this.militaryFormDetails;
        this.setMilitaryStateList = this.stateListMilitary;
    }

    get getMilitaryService() {
        return this.facOpsDataService.militaryInfo;
    }
    set setMilitaryService(value) {
        this.facOpsDataService.militaryInfo = value;
    }

    get getMilitaryStateList() {
        return this.facOpsDataService.militaryStateList;
    }
    set setMilitaryStateList(value) {
        this.facOpsDataService.militaryStateList = value;
    }

    openModal(template: TemplateRef<any>) {
        this.modalRef = this.modalWrapper.openTemplate(template, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
    }

    cancelmilitaryForm(template: TemplateRef<any>) {
        if (this.militaryForm.dirty === true) {
            this.openModal(template);
        } else {
            this.militaryForm.reset();
            this.militaryModal.hide();
            if (this.modalRef) { this.modalRef.hide(); }
            this.militaryForm.patchValue({
                COCountry: this.defaultCountryId,
                COState: ''
            });
            if (!this.militaryForm.get('COCellPhoneDialInCode').dirty) {
                this.militaryForm.patchValue({ COCellPhoneDialInCode: this.defaultCountryId });
            } else { }
            if (!this.militaryForm.get('COFaxDialInCode').dirty) {
                this.militaryForm.patchValue({ COFaxDialInCode: this.defaultCountryId });
            }
            this.militaryForm.markAsUntouched();
            this.militaryForm.markAsPristine();
            this.tempisMilitaryChecked = this.isMilitaryChecked;
        }
    }

    onCancelMilitary() {
        this.militaryForm.reset();
        this.militaryModal.hide();
        this.militaryForm.patchValue({
            COCountry: this.defaultCountryId,
            COState: ''
        });
        if (!this.militaryForm.get('COCellPhoneDialInCode').dirty) {
            this.militaryForm.patchValue({ COCellPhoneDialInCode: this.defaultCountryId });
        } else { }
        if (!this.militaryForm.get('COFaxDialInCode').dirty) {
            this.militaryForm.patchValue({ COFaxDialInCode: this.defaultCountryId });
        }
        this.militaryForm.markAsUntouched();
        this.militaryForm.markAsPristine();
        this.tempisMilitaryChecked = this.isMilitaryChecked;
        if (this.modalRef) { this.modalRef.hide(); }
        //removing model pop-up class manully
        if ((document.querySelector('body') as HTMLElement).classList?.contains('modal-open')) {
            (document.querySelector('body') as HTMLElement).classList.remove('modal-open');
        }
    }

    onCloseMilitary() {
        if (this.militaryFormDetails) {
            this.militaryForm.patchValue({
                ServiceMemberName: this.militaryFormDetails.ServiceMemberName,
                DOD: this.militaryFormDetails.DOD,
                MilitaryDeploymentDate: this.militaryFormDetails.MilitaryDeploymentDate,
                MilitaryIdExpDate: this.militaryFormDetails.MilitaryIdExpDate,
                MilitaryRank: this.militaryFormDetails.MilitaryRank,
                MilitaryUnitName: this.militaryFormDetails.MilitaryUnitName,
                COFirstName: this.militaryFormDetails.COFirstName === null ? '' : this.militaryFormDetails.COFirstName,
                COLastName: this.militaryFormDetails.COLastName === null ? '' : this.militaryFormDetails.COLastName,
                CORank: this.militaryFormDetails.CORank === null ? '' : this.militaryFormDetails.CORank,
                COAddress: this.militaryFormDetails.COAddress === null ? '' : this.militaryFormDetails.COAddress,
                COCity: this.militaryFormDetails.COCity === null ? '' : this.militaryFormDetails.COCity,
                COState: this.militaryFormDetails.COState,
                COZipCode: this.militaryFormDetails.COZipCode === null ? '' : this.militaryFormDetails.COZipCode,
                COCountry: this.militaryFormDetails.COCountry == '' || this.militaryFormDetails.COCountry == null ? this.countryId : this.militaryFormDetails.COCountry,
                COCellPhone: this.militaryFormDetails.COCellPhone === null ? '' : this.militaryFormDetails.COCellPhone,
                COCellPhoneDialInCode: this.militaryFormDetails.COCellPhoneDialInCode,
                COFax: this.militaryFormDetails.COFax === null ? '' : this.militaryFormDetails.COFax,
                COFaxDialInCode: this.militaryFormDetails.COFaxDialInCode,
                COEmail: this.militaryFormDetails.COEmail === null ? '' : this.militaryFormDetails.COEmail,
                MilitaryBase: this.militaryFormDetails.MilitaryBase === null ? '' : this.militaryFormDetails.MilitaryBase,
                MilitaryBranch: this.militaryFormDetails.MilitaryBranch === null ? '' : this.militaryFormDetails.MilitaryBranch
            });
        } else {
            this.militaryForm.reset();
            this.militaryForm.patchValue({
                COCountry: this.defaultCountryId,
                COState: ''
            });
            if (!this.militaryForm.get('COCellPhoneDialInCode').dirty) {
                this.militaryForm.patchValue({ COCellPhoneDialInCode: this.defaultCountryId });
            } else { }
            if (!this.militaryForm.get('COFaxDialInCode').dirty) {
                this.militaryForm.patchValue({ COFaxDialInCode: this.defaultCountryId });
            }
            this.tempisMilitaryChecked = this.isMilitaryChecked;
            this.militaryForm.markAsUntouched();
            this.militaryForm.markAsPristine();
            this.modalRef.hide();
        }
    }

    isRequired(control) {
        if (this.militaryForm.get(control).validator !== null) {
            const validator = this.militaryForm.get(control).validator({} as AbstractControl);
            return validator && validator.required ? true : false;
        } else {
            return false
        }
    }

     setMandatoryField() {
     this.generalService.GetMandatoryFields(this.userSessionService.userSessionData.LastAccessedStoreId, this.componentname,this.formName)
         .subscribe((response: IGetPermissionMandatoryField) => {
             var data = response;
             if (data.Form.ListOfProperties.length != 0) {
                 this.militaryInfoReqList = data.Form.ListOfProperties;
                 data.Form.ListOfProperties.forEach(field => {
                     var formControlName = field.Name.startsWith("COI") ? field.Name.replace(/^COI/, "CO") : field.Name;
                     const fieldNameMap = {
                       'DODNumber': 'DOD',
                       'COCellPhoneCountryId': 'COCellPhoneDialInCode',
                       'COCountryId': 'COCountry',
                       'COFaxCountryId': 'COFaxDialInCode',
                       'Rank': 'MilitaryRank',
                       'COZip': 'COZipCode',
                       'MilitaryActiveDutyDate': 'MilitaryDeploymentDate',
                     };
                    formControlName = fieldNameMap[formControlName] || formControlName;
                     if ((formControlName == 'DOD') || (formControlName == 'MilitaryRank') || (formControlName == 'COFirstName') || (formControlName == 'COLastName')
                         || (formControlName == 'CORank') || (formControlName == 'COAddress') || (formControlName == 'COCity') || (formControlName == 'MilitaryBranch')
                         || (formControlName == 'MilitaryBase') || (formControlName == 'COZipCode')|| (formControlName == 'ServiceMemberName') 
                         || (formControlName == 'MilitaryUnitName')) {
                         if (field.Required) {
                                this.militaryForm.get(formControlName).setValidators([this.generalService.noWhitespaceValidator, Validators.required]);
                            } else {
                                 this.militaryForm.get(formControlName).setValidators([this.generalService.noWhitespaceValidator]);                 
                                  }
                         } else if (formControlName == 'COEmail') {
                         if (field.Required) {
                            this.militaryForm.get(formControlName).setValidators([Validators.pattern(this.emailIdsPattern), Validators.required]);
                         } else {
                             this.militaryForm.get(formControlName).setValidators([Validators.pattern(this.emailIdsPattern)]);
                         }
                     } else if (formControlName == 'COFax' || formControlName == 'COCellPhone') {
                         if (field.Required) {
                             this.militaryForm.get(formControlName).setValidators([this.cellPhoneValidator, Validators.required]);
                         } else {
                             this.militaryForm.get(formControlName).setValidators([this.cellPhoneValidator]);
                         }
                     } else if (field.Required) {
                         this.militaryForm.get(formControlName).setValidators([Validators.required]);
                     } else {
                         this.militaryForm.get(formControlName).setValidators(null);
                     }
                         this.militaryForm.get(formControlName).updateValueAndValidity();                               
                 });
             }
         });
 }

    public cellPhoneValidator(control: FormControl) {
        if ((control.value !== '') && (control.value !== null)) {
            if (control.value) {
                const isWhitespace = (control.value).trim().length < 10;
                const isValid = !isWhitespace;

                return isValid ? null : { 'lessThanTen': true };
            }
        }
    }

    clearForm() {
        this.militaryForm.reset();
        this.militaryForm.patchValue({
            COCountry: this.defaultCountryId,
            COState: ''
        });
        if (!this.militaryForm.get('COCellPhoneDialInCode').dirty) {
            this.militaryForm.patchValue({ COCellPhoneDialInCode: this.defaultCountryId });
        } else { }
        if (!this.militaryForm.get('COFaxDialInCode').dirty) {
            this.militaryForm.patchValue({ COFaxDialInCode: this.defaultCountryId });
        }
        this.setMilitaryService = null;
        this.militaryInfoSaved = false;
        this.militaryFilled.emit(this.militaryInfoSaved);
    }

    restrictSpace(eve) {
        if (eve.which === 32) {
            eve.preventDefault();
        }
    }

    militaryexpdatechange(expDate) {
        this.militaryForm.patchValue({ MilitaryIdExpDate: expDate })
    }

    militaryDeploymentDateChange(startDate) {
        this.militaryForm.patchValue({ MilitaryDeploymentDate: startDate })
    }

    onChangeMilitaryExpDate(args) {
        let e = document.getElementById('MilitaryIdExpDate');
        if (args) {
            e.classList.add('isValid');
        } else {
            e.classList.remove('isValid');
        }
    }

    onChangeMilitaryDeploymentDate(args) {
        let e = document.getElementById('MilitaryDeploymentDate');
        if (args) {
            e.classList.add('isValid');
        } else {
            e.classList.remove('isValid');
        }
    }

    closeMilitaryCallScript() {
        document.getElementById("military-close-button").click();
    }

    saveMilitaryCallScript() {
        document.getElementById("military-save-button").click();
    }

    validateZipInput(eve){
        this.commonMethodService.validateZipInput(eve);
      }
}
